const module = { name: 'shared/misc/historyManager', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



let enabled = false


let lastIndex = -1


let locationPath = ''


let locationSearch = ''


let onChange
function saveLocation(index) {
    if (!enabled || !window.history || !window.history.pushState) {
        return;
    }
    index = parseInt(index, 10);
    if (!index || index === lastIndex) {
        return;
    }
    lastIndex = index;
    const url = locationPath + (index < 2 ? '' : ('/slide/' + index)) + locationSearch;
    window.history.pushState({
        index
    }, 'goto-' + index, url);
}
function onPopState(e) {
    let state = (window.history && window.history.state) ? window.history.state : false;
    if (!state && e && e.originalEvent && e.originalEvent.state) {
        state = e.originalEvent.state;
    }
    if (state && state.index) {
        lastIndex = parseInt(state.index, 10);
        if (typeof cb === 'function') {
            onChange(state.index);
        }
    }
}
function init(opts) {
    opts = opts || {};
    enabled = true;
    onChange = opts.onChange;
    locationSearch = window.location.search;
    locationPath = window.location.pathname.replace(/\/slide\/\d+$/, '');
    $(window).on('popstate', onPopState);
}
module.exports = {
    init,
    saveLocation
};
export default module.exports;